/**
 * Date Utils
 */

import { DateTime, Duration } from 'luxon';

export function getFormattedTime(seconds: number) {
  return Duration.fromObject({ seconds }).toFormat('mm:ss');
}

export function getTimestamp() {
  return DateTime.local().toString();
}

export function getFormattedDateToday() {
  return DateTime.local().setLocale('en-us').toFormat('y-LL-dd');
}

export function getFormattedDateFromGraphQL(date: string) {
  return DateTime.fromISO(date, { zone: 'utc' }).setLocale('en-us').toLocaleString(DateTime.DATE_FULL);
}

export function isPastDue(date: string) {
  const now = DateTime.local();
  const dateToValidate = DateTime.fromISO(date);
  return dateToValidate < now;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/date.ts